import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPageBackground} from '@Components/poster-editor/poster-editor-reducer';
import {BaseTintOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-tint-option';
import {useAppSelector} from '@/hooks';
import type {RGBA} from '@Utils/color.util';
import {BackgroundTypeName} from "@PosterWhiteboard/page/background/background.types";

interface ImageBgTintOptionProps {
  onClickColorFill(): void;
}

export function ImageBgTintOption({...props}: ImageBgTintOptionProps): ReactElement<any> | null {
  const currentPageBackground = useAppSelector(getCurrentPageBackground);
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();

  if (!currentPageBackground) {
    return null;
  }

  if (currentPageBackground.details.type !== BackgroundTypeName.IMAGE) {
    return null;
  }

  const imageDetails = currentPageBackground.details;

  const onToggleTint = (): void => {
    void currentPage?.background.updateFromObject({
      details: {
        effects: {
          tint: !imageDetails.effects.tint,
        },
      },
    });
  };

  const onClickColorFill = (): void => {
    props.onClickColorFill();
  };

  const onUpdateOpacity = (tintOpacity: number, undoable = true): void => {
    const tintColor = imageDetails.effects.tintColor.slice() as RGBA;
    tintColor[3] = tintOpacity;
    void currentPage?.background.updateFromObject(
      {
        details: {
          effects: {
            tintColor,
          },
        },
      },
      {undoable}
    );
  };

  return (
    <BaseTintOption
      tint={imageDetails.effects.tint}
      tintOpacity={imageDetails.effects.tintColor[3]}
      tintColor={imageDetails.effects.tintColor}
      onToggleTint={onToggleTint}
      onClickColorFill={onClickColorFill}
      updateOpacity={onUpdateOpacity}
    />
  );
}
